export default "__VITE_ASSET__B9nQX1R2__"